import React from 'react';

const MultiSelectGrid = ({
  label,
  options = [],
  value = [],
  onChange,
  minWidth = '140px',
  hint = null
}) => {
  const handleToggle = (optionValue) => {
    if (value.includes(optionValue)) {
      // Remove from selection
      onChange(value.filter(v => v !== optionValue));
    } else {
      // Add to selection
      onChange([...value, optionValue]);
    }
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      {label && (
        <label style={{
          display: 'block',
          fontSize: '14px',
          fontWeight: '500',
          color: 'var(--color-text-secondary)',
          marginBottom: '8px'
        }}>
          {label}
          {value.length > 0 && (
            <span style={{
              display: 'inline-block',
              background: 'var(--color-info-bg)',
              color: 'var(--color-info-hover)',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: '11px',
              fontWeight: '600',
              marginLeft: '8px'
            }}>
              {value.length} selected
            </span>
          )}
        </label>
      )}

      <div style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}, 1fr))`,
        gap: '10px'
      }}>
        {options.map((option) => {
          const optionValue = typeof option === 'string' ? option : option.value;
          const optionLabel = typeof option === 'string' ? option : option.label;
          const isChecked = value.includes(optionValue);

          return (
            <label
              key={optionValue}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 12px',
                border: `1px solid ${isChecked ? 'var(--color-info-hover)' : 'var(--color-border)'}`,
                background: isChecked ? 'var(--color-info-bg)' : 'white',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s',
                userSelect: 'none'
              }}
            >
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => handleToggle(optionValue)}
                style={{
                  width: '16px',
                  height: '16px',
                  cursor: 'pointer',
                  accentColor: 'var(--color-info-hover)'
                }}
              />
              <span style={{
                fontSize: '13px',
                color: isChecked ? 'var(--color-info-fg)' : 'var(--color-text-secondary)',
                fontWeight: isChecked ? '500' : '400',
                flex: 1
              }}>
                {optionLabel}
              </span>
            </label>
          );
        })}
      </div>

      {hint && (
        <div style={{
          fontSize: '12px',
          color: 'var(--color-text-muted)',
          marginTop: '4px'
        }}>
          {hint}
        </div>
      )}
    </div>
  );
};

export default MultiSelectGrid;
